import * as Yup from "yup";

// Validation schema for the login form
export const ForgetPassSchema = Yup.object().shape({
  mobileNumber: Yup.string().required("شماره موبایل الزامی است"),
});
